// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"C2-z","upvote":"D2-z","downvote":"E2-z","numVotes":"F2-z","votesDescription":"G2-z","report":"H2-z","voted":"I2-z","answerVoteBox":"J2-z","justReported":"K2-z"};